import { Box, Image, ScrollArea, Stack } from '@mantine/core';
import { AsideFriendMessage } from './AsideFriendMessage';
import { AsideMyMessage } from './AsideMyMessage';
export const AsideChat: React.FC = () => {
  return <Box pos="relative">
      <Image src="/assets/aside/deco.png" pos="absolute" top={0} style={{
      zIndex: 1
    }} alt="shadow" />
      <ScrollArea h={{
      base: 'calc(100vh - 350px)',
      sm: 'calc(100vh - 190px)',
      md: 'calc(100vh - 300px)'
    }} type="hover" scrollbars="y">
        <Stack gap={0} px={{
        base: 10,
        sm: 0
      }}>
          <AsideFriendMessage isTag tag="@chapa" text="mostly i did sleep late, woke up at 10" />
          <AsideFriendMessage isAvatar isLevel level="LV4" isTag tag="@chapa" username="sonnysol" text="mostly i did sleep late, woke up at 10" />
          <AsideFriendMessage text="I’m winning big time on xflip 2/2, time to party" />
          <AsideMyMessage text="Alright I’m leaving for the day" />
          <AsideFriendMessage isAvatar username="sonnysol" text="well i guess u should allways remember from what uve strarted" />
          <AsideFriendMessage isAvatar isTag tag="@chapa" username="sonnysol" text="mostly i did sleep late, woke up at 10" />
          <AsideFriendMessage isAvatar username="sonnysol" text="any code?" />
          <AsideMyMessage text="You see, I'm an optimist, so that could potentially be a good thing as well 😂" />
          <AsideMyMessage text="You see, I'm an optimist, so that could potentially be a good thing as well 😂" />

          <AsideMyMessage text="You see, I'm an optimist, so that could potentially be a good thing as well 😂" />
        </Stack>
      </ScrollArea>
    </Box>;
};